import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { colorToHex } from '../../../../features/pipeline/pipeline-model.ts';
import Button from '../svelte-button.svelte';
import DropdownMenu from '../svelte-dropdown-menu.svelte';
import { formatPositionPercent, scheduleSelectAllTextIfFocused } from './shared.ts';
import { SvelteMap } from 'svelte/reactivity';

var root = $.from_html(`<span class="ui-symbol-kebab">...</span>`);
var root_1 = $.from_html(`<button type="button" class="ui-menu-item" role="menuitem"> </button> <button type="button" class="ui-menu-item" role="menuitem"> </button>`, 1);
var root_2 = $.from_html(`<div></div>`);
var root_3 = $.from_html(`<div class="stop-preview-area svelte-4f3bkg"><div class="stop-preview svelte-4f3bkg"></div></div>`);
var root_4 = $.from_html(`<div class="stop-editor svelte-4f3bkg"><div class="stop-editor-field svelte-4f3bkg"><label class="editor-label svelte-4f3bkg" for="lut-editor-stop-color"> </label> <input id="lut-editor-stop-color" type="color" class="stop-color-input svelte-4f3bkg"/></div> <div class="stop-editor-field svelte-4f3bkg"><label class="editor-label svelte-4f3bkg" for="lut-editor-stop-position"> </label> <input id="lut-editor-stop-position" type="text" inputmode="decimal" class="pos-input svelte-4f3bkg"/> <span class="editor-unit svelte-4f3bkg">%</span></div> <div class="stop-editor-field svelte-4f3bkg"><label class="editor-label svelte-4f3bkg" for="lut-editor-stop-alpha"> </label> <input id="lut-editor-stop-alpha" type="range" class="stop-alpha-input svelte-4f3bkg" min="0" max="100"/> <span class="editor-unit svelte-4f3bkg"> </span></div></div>`);
var root_5 = $.from_html(`<div class="empty-note svelte-4f3bkg"> </div>`);
var root_6 = $.from_html(`<div class="stop-section svelte-4f3bkg"><div class="section-header svelte-4f3bkg"><div class="section-label svelte-4f3bkg"> </div> <div class="section-header-actions svelte-4f3bkg"><!> <!> <!></div></div> <!> <!></div>`);

const $$css = {
	hash: 'svelte-4f3bkg',
	code: '.stop-section.svelte-4f3bkg {display:flex;flex-direction:column;flex:1;overflow:auto;padding:12px 16px;gap:8px;}.section-header.svelte-4f3bkg {display:flex;align-items:center;justify-content:space-between;gap:8px;}.section-header-actions.svelte-4f3bkg {display:flex;align-items:stretch;gap:8px;flex-shrink:0;}.section-label.svelte-4f3bkg {font-size:11px;font-weight:600;color:var(--color-muted);text-transform:uppercase;letter-spacing:0.04em;}.stop-preview-area.svelte-4f3bkg {flex-shrink:0;}.stop-preview.svelte-4f3bkg {position:relative;width:100%;height:18px;border-radius:4px;border:1px solid var(--color-control-border);overflow:visible;margin:14px 0;}.preview-stop-knob.svelte-4f3bkg {position:absolute;width:12px;height:12px;border-radius:50%;border:2px solid color-mix(in srgb, var(--color-bg), transparent 70%);transform:translateX(-50%);cursor:ew-resize;touch-action:none;transition:box-shadow 0.1s;top:calc(100% + 3px);}.above.svelte-4f3bkg {top:auto;bottom:calc(100% + 3px);}.focused.svelte-4f3bkg {box-shadow:0 0 0 2px var(--color-accent);}.boundary.svelte-4f3bkg {opacity:0.6;}.stop-editor.svelte-4f3bkg {display:flex;flex-direction:column;gap:10px;}.stop-editor-field.svelte-4f3bkg {display:flex;align-items:center;gap:8px;}.editor-label.svelte-4f3bkg {font-size:11px;color:var(--color-muted);min-width:52px;flex-shrink:0;}.editor-unit.svelte-4f3bkg {font-size:11px;color:var(--color-muted);font-variant-numeric:tabular-nums;min-width:34px;}.pos-input.svelte-4f3bkg {width:calc(6ch + 16px);box-sizing:content-box;font-size:12px;padding:3px 6px;border:1px solid var(--color-control-border);border-radius:4px;background:var(--color-surface-inset);color:var(--color-text);font-variant-numeric:tabular-nums;text-align:right;}.stop-color-input.svelte-4f3bkg {width:32px;height:22px;padding:0;border:none;border-radius:3px;cursor:pointer;background:none;}.stop-alpha-input.svelte-4f3bkg {width:100%;height:4px;accent-color:var(--color-accent);}.empty-note.svelte-4f3bkg {font-size:12px;color:var(--color-muted);padding:12px 0;}'
};

export default function Lut_editor_stop_section($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	const selectedRamp = $.prop($$props, 'selectedRamp', 7, null),
		focusedStop = $.prop($$props, 'focusedStop', 7, null),
		stopPositionDraft = $.prop($$props, 'stopPositionDraft', 7, ''),
		editingStopPositionId = $.prop($$props, 'editingStopPositionId', 7, null),
		stopEditorLabel = $.prop($$props, 'stopEditorLabel', 7, ''),
		addStopLabel = $.prop($$props, 'addStopLabel', 7, ''),
		removeStopLabel = $.prop($$props, 'removeStopLabel', 7, ''),
		duplicateStopLabel = $.prop($$props, 'duplicateStopLabel', 7, ''),
		invertStopLabel = $.prop($$props, 'invertStopLabel', 7, ''),
		stopMenuAriaLabel = $.prop($$props, 'stopMenuAriaLabel', 7, ''),
		stopColorLabel = $.prop($$props, 'stopColorLabel', 7, ''),
		stopPositionLabel = $.prop($$props, 'stopPositionLabel', 7, ''),
		alphaLabel = $.prop($$props, 'alphaLabel', 7, ''),
		noStopSelectedLabel = $.prop($$props, 'noStopSelectedLabel', 7, ''),
		maxStopsReached = $.prop($$props, 'maxStopsReached', 7, false),
		isStopBoundary = $.prop($$props, 'isStopBoundary', 7, () => false),
		onAddStop = $.prop($$props, 'onAddStop', 7, () => undefined),
		onRemoveStop = $.prop($$props, 'onRemoveStop', 7, () => undefined),
		onDuplicateFocusedStop = $.prop($$props, 'onDuplicateFocusedStop', 7, () => undefined),
		onInvertFocusedStop = $.prop($$props, 'onInvertFocusedStop', 7, () => undefined),
		onSelectStop = $.prop($$props, 'onSelectStop', 7, () => undefined),
		onPreviewStopPointerDown = $.prop($$props, 'onPreviewStopPointerDown', 7, () => undefined),
		onStopColorInput = $.prop($$props, 'onStopColorInput', 7, () => undefined),
		onBeginStopPositionEdit = $.prop($$props, 'onBeginStopPositionEdit', 7, () => undefined),
		onStopPositionInput = $.prop($$props, 'onStopPositionInput', 7, () => undefined),
		onCommitStopPosition = $.prop($$props, 'onCommitStopPosition', 7, () => undefined),
		onCancelStopPositionEdit = $.prop($$props, 'onCancelStopPositionEdit', 7, () => undefined),
		onStopPositionWheel = $.prop($$props, 'onStopPositionWheel', 7, () => undefined),
		onStopAlphaInput = $.prop($$props, 'onStopAlphaInput', 7, () => undefined),
		onStopAlphaWheel = $.prop($$props, 'onStopAlphaWheel', 7, () => undefined);

	let stopPositionInputRef = $.state(null);
	let stopPreviewBarRef = $.state(null);
	const stopKnobPlacementMap = $.derived(() => computeStopKnobPlacements(selectedRamp(), $.get(stopPreviewBarRef)));

	function computeStopKnobPlacements(ramp, bar) {
		const placements = new SvelteMap();

		if (!ramp) {
			return placements;
		}

		const rawWidth = bar?.getBoundingClientRect().width ?? 0;
		const barWidth = rawWidth > 0 ? rawWidth : 256;
		const threshold = 14 / barWidth;
		const sorted = [...ramp.stops].sort((a, b) => a.position - b.position);
		let lastBelowPos = -Infinity;
		let lastAbovePos = -Infinity;

		for (const stop of sorted) {
			const belowClear = stop.position - lastBelowPos >= threshold;
			const aboveClear = stop.position - lastAbovePos >= threshold;

			if (belowClear) {
				placements.set(stop.id, 'below');
				lastBelowPos = stop.position;
			} else if (aboveClear) {
				placements.set(stop.id, 'above');
				lastAbovePos = stop.position;
			} else {
				placements.set(stop.id, 'below');
				lastBelowPos = stop.position;
			}
		}

		return placements;
	}

	function rampSwatchStyle(ramp) {
		const stops = ramp.stops.map((stop) => `${colorToHex(stop.color)} ${Math.round(stop.position * 100)}%`);

		return `background: linear-gradient(to right, ${stops.join(', ')})`;
	}

	var $$exports = {
		get selectedRamp() {
			return selectedRamp();
		},

		set selectedRamp($$value = null) {
			selectedRamp($$value);
			$.flush();
		},

		get focusedStop() {
			return focusedStop();
		},

		set focusedStop($$value = null) {
			focusedStop($$value);
			$.flush();
		},

		get stopPositionDraft() {
			return stopPositionDraft();
		},

		set stopPositionDraft($$value = '') {
			stopPositionDraft($$value);
			$.flush();
		},

		get editingStopPositionId() {
			return editingStopPositionId();
		},

		set editingStopPositionId($$value = null) {
			editingStopPositionId($$value);
			$.flush();
		},

		get stopEditorLabel() {
			return stopEditorLabel();
		},

		set stopEditorLabel($$value = '') {
			stopEditorLabel($$value);
			$.flush();
		},

		get addStopLabel() {
			return addStopLabel();
		},

		set addStopLabel($$value = '') {
			addStopLabel($$value);
			$.flush();
		},

		get removeStopLabel() {
			return removeStopLabel();
		},

		set removeStopLabel($$value = '') {
			removeStopLabel($$value);
			$.flush();
		},

		get duplicateStopLabel() {
			return duplicateStopLabel();
		},

		set duplicateStopLabel($$value = '') {
			duplicateStopLabel($$value);
			$.flush();
		},

		get invertStopLabel() {
			return invertStopLabel();
		},

		set invertStopLabel($$value = '') {
			invertStopLabel($$value);
			$.flush();
		},

		get stopMenuAriaLabel() {
			return stopMenuAriaLabel();
		},

		set stopMenuAriaLabel($$value = '') {
			stopMenuAriaLabel($$value);
			$.flush();
		},

		get stopColorLabel() {
			return stopColorLabel();
		},

		set stopColorLabel($$value = '') {
			stopColorLabel($$value);
			$.flush();
		},

		get stopPositionLabel() {
			return stopPositionLabel();
		},

		set stopPositionLabel($$value = '') {
			stopPositionLabel($$value);
			$.flush();
		},

		get alphaLabel() {
			return alphaLabel();
		},

		set alphaLabel($$value = '') {
			alphaLabel($$value);
			$.flush();
		},

		get noStopSelectedLabel() {
			return noStopSelectedLabel();
		},

		set noStopSelectedLabel($$value = '') {
			noStopSelectedLabel($$value);
			$.flush();
		},

		get maxStopsReached() {
			return maxStopsReached();
		},

		set maxStopsReached($$value = false) {
			maxStopsReached($$value);
			$.flush();
		},

		get isStopBoundary() {
			return isStopBoundary();
		},

		set isStopBoundary($$value = () => false) {
			isStopBoundary($$value);
			$.flush();
		},

		get onAddStop() {
			return onAddStop();
		},

		set onAddStop($$value = () => undefined) {
			onAddStop($$value);
			$.flush();
		},

		get onRemoveStop() {
			return onRemoveStop();
		},

		set onRemoveStop($$value = () => undefined) {
			onRemoveStop($$value);
			$.flush();
		},

		get onDuplicateFocusedStop() {
			return onDuplicateFocusedStop();
		},

		set onDuplicateFocusedStop($$value = () => undefined) {
			onDuplicateFocusedStop($$value);
			$.flush();
		},

		get onInvertFocusedStop() {
			return onInvertFocusedStop();
		},

		set onInvertFocusedStop($$value = () => undefined) {
			onInvertFocusedStop($$value);
			$.flush();
		},

		get onSelectStop() {
			return onSelectStop();
		},

		set onSelectStop($$value = () => undefined) {
			onSelectStop($$value);
			$.flush();
		},

		get onPreviewStopPointerDown() {
			return onPreviewStopPointerDown();
		},

		set onPreviewStopPointerDown($$value = () => undefined) {
			onPreviewStopPointerDown($$value);
			$.flush();
		},

		get onStopColorInput() {
			return onStopColorInput();
		},

		set onStopColorInput($$value = () => undefined) {
			onStopColorInput($$value);
			$.flush();
		},

		get onBeginStopPositionEdit() {
			return onBeginStopPositionEdit();
		},

		set onBeginStopPositionEdit($$value = () => undefined) {
			onBeginStopPositionEdit($$value);
			$.flush();
		},

		get onStopPositionInput() {
			return onStopPositionInput();
		},

		set onStopPositionInput($$value = () => undefined) {
			onStopPositionInput($$value);
			$.flush();
		},

		get onCommitStopPosition() {
			return onCommitStopPosition();
		},

		set onCommitStopPosition($$value = () => undefined) {
			onCommitStopPosition($$value);
			$.flush();
		},

		get onCancelStopPositionEdit() {
			return onCancelStopPositionEdit();
		},

		set onCancelStopPositionEdit($$value = () => undefined) {
			onCancelStopPositionEdit($$value);
			$.flush();
		},

		get onStopPositionWheel() {
			return onStopPositionWheel();
		},

		set onStopPositionWheel($$value = () => undefined) {
			onStopPositionWheel($$value);
			$.flush();
		},

		get onStopAlphaInput() {
			return onStopAlphaInput();
		},

		set onStopAlphaInput($$value = () => undefined) {
			onStopAlphaInput($$value);
			$.flush();
		},

		get onStopAlphaWheel() {
			return onStopAlphaWheel();
		},

		set onStopAlphaWheel($$value = () => undefined) {
			onStopAlphaWheel($$value);
			$.flush();
		}
	};

	var div = root_6();
	var div_1 = $.child(div);
	var div_2 = $.child(div_1);
	var text = $.only_child(div_2, true);
	var div_3 = $.sibling(div_2, 2);
	var node = $.child(div_3);

	{
		let $0 = $.derived(() => maxStopsReached() || !selectedRamp());

		Button(node, {
			variant: 'secondary',
			get handlePress() {
				return onAddStop();
			},

			get disabled() {
				return $.get($0);
			},

			children: ($$anchor, $$slotProps) => {
				$.next();

				var text_1 = $.text();

				$.template_effect(() => $.set_text(text_1, addStopLabel()));
				$.append($$anchor, text_1);
			},
			$$slots: { default: true }
		});
	}

	var node_1 = $.sibling(node, 2);

	{
		var consequent = ($$anchor) => {
			Button($$anchor, {
				variant: 'destructive',
				handlePress: () => onRemoveStop()(focusedStop().id),
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_2 = $.text();

					$.template_effect(() => $.set_text(text_2, removeStopLabel()));
					$.append($$anchor, text_2);
				},
				$$slots: { default: true }
			});
		};

		var d = $.derived(() => focusedStop() && !isStopBoundary()(focusedStop().id));

		$.if(node_1, ($$render) => {
			if ($.get(d)) $$render(consequent);
		});
	}

	var node_2 = $.sibling(node_1, 2);

	{
		var consequent_1 = ($$anchor) => {
			{
				const trigger = ($$anchor) => {
					var span = root();

					$.append($$anchor, span);
				};

				const children = ($$anchor, closeMenu = $.noop) => {
					var fragment_4 = root_1();
					var button = $.first_child(fragment_4);
					var text_3 = $.only_child(button, true);
					var button_1 = $.sibling(button, 2);
					var text_4 = $.only_child(button_1, true);

					$.template_effect(() => {
						button.disabled = maxStopsReached();
						$.set_text(text_3, duplicateStopLabel());
						$.set_text(text_4, invertStopLabel());
					});

					$.delegated('click', button, () => {
						closeMenu()();
						onDuplicateFocusedStop()();
					});

					$.delegated('click', button_1, () => {
						closeMenu()();
						onInvertFocusedStop()();
					});

					$.append($$anchor, fragment_4);
				};

				DropdownMenu($$anchor, {
					wrapperClass: 'lut-editor-menu-wrap',
					menuClass: 'ui-menu lut-editor-menu-panel lut-editor-kebab-menu',
					triggerClassName: 'ui-menu-trigger',
					triggerVariant: 'menu-trigger',
					get triggerAriaLabel() {
						return stopMenuAriaLabel();
					},
					menuRole: 'menu',
					floating: true,
					trigger,
					children,
					$$slots: { trigger: true, default: true }
				});
			}
		};

		$.if(node_2, ($$render) => {
			if (focusedStop()) $$render(consequent_1);
		});
	}

	$.reset(div_3);
	$.reset(div_1);

	var node_3 = $.sibling(div_1, 2);

	{
		var consequent_2 = ($$anchor) => {
			var div_4 = root_3();
			var div_5 = $.child(div_4);

			$.each(div_5, 21, () => selectedRamp().stops, (stop) => stop.id, ($$anchor, stop) => {
				var div_6 = root_2();

				$.template_effect(
					($0, $1) => {
						$.set_class(div_6, 1, $0, 'svelte-4f3bkg');
						$.set_style(div_6, $1);
					},
					[
						() => $.clsx(`preview-stop-knob ${($.get(stopKnobPlacementMap).get($.get(stop).id) ?? 'below') === 'above' ? 'above' : ''} ${focusedStop()?.id === $.get(stop).id ? 'focused' : ''} ${isStopBoundary()($.get(stop).id) ? 'boundary' : ''}`.trim()),
						() => `left:${$.get(stop).position * 100}%;background-color:${colorToHex($.get(stop).color)}`
					]
				);

				$.delegated('pointerdown', div_6, (event) => {
					event.preventDefault();
					event.stopPropagation();
					onSelectStop()($.get(stop).id);
					onPreviewStopPointerDown()($.get(stop).id, event, $.get(stopPreviewBarRef));
				});

				$.append($$anchor, div_6);
			});

			$.reset(div_5);
			$.bind_this(div_5, ($$value) => $.set(stopPreviewBarRef, $$value), () => $.get(stopPreviewBarRef));
			$.reset(div_4);
			$.template_effect(($0) => $.set_style(div_5, $0), [() => rampSwatchStyle(selectedRamp())]);
			$.append($$anchor, div_4);
		};

		$.if(node_3, ($$render) => {
			if (selectedRamp()) $$render(consequent_2);
		});
	}

	var node_4 = $.sibling(node_3, 2);

	{
		var consequent_3 = ($$anchor) => {
			var div_7 = root_4();
			var div_8 = $.child(div_7);
			var label = $.child(div_8);
			var text_5 = $.only_child(label, true);
			var input = $.sibling(label, 2);

			$.remove_input_defaults(input);
			$.reset(div_8);

			var div_9 = $.sibling(div_8, 2);
			var label_1 = $.child(div_9);
			var text_6 = $.only_child(label_1, true);
			var input_1 = $.sibling(label_1, 2);

			$.remove_input_defaults(input_1);
			$.bind_this(input_1, ($$value) => $.set(stopPositionInputRef, $$value), () => $.get(stopPositionInputRef));
			$.next(2);
			$.reset(div_9);

			var div_10 = $.sibling(div_9, 2);
			var label_2 = $.child(div_10);
			var text_7 = $.only_child(label_2, true);
			var input_2 = $.sibling(label_2, 2);

			$.remove_input_defaults(input_2);

			var span_1 = $.sibling(input_2, 2);
			var text_8 = $.only_child(span_1);

			$.reset(div_10);
			$.reset(div_7);

			$.template_effect(
				($0, $1, $2, $3) => {
					$.set_text(text_5, stopColorLabel());
					$.set_value(input, $0);
					$.set_text(text_6, stopPositionLabel());
					$.set_value(input_1, $1);
					$.set_text(text_7, alphaLabel());
					$.set_value(input_2, $2);
					$.set_text(text_8, `${$3 ?? ''}%`);
				},
				[
					() => colorToHex(focusedStop().color),
					() => editingStopPositionId() === focusedStop().id
						? stopPositionDraft()
						: formatPositionPercent(focusedStop().position),
					() => Math.round(focusedStop().alpha * 100),
					() => Math.round(focusedStop().alpha * 100)
				]
			);

			$.delegated('input', input, (event) => onStopColorInput()(focusedStop().id, event.currentTarget.value));

			$.event('focus', input_1, () => {
				onBeginStopPositionEdit()(focusedStop().id, formatPositionPercent(focusedStop().position));
				scheduleSelectAllTextIfFocused($.get(stopPositionInputRef) ?? undefined);
			});

			$.delegated('input', input_1, (event) => onStopPositionInput()(focusedStop().id, event.currentTarget.value));
			$.event('blur', input_1, () => onCommitStopPosition()(focusedStop().id));

			$.delegated('keydown', input_1, (event) => {
				if (event.key === 'Enter') {
					event.currentTarget.blur();
				} else if (event.key === 'Escape') {
					onCancelStopPositionEdit()(formatPositionPercent(focusedStop().position));
					event.currentTarget.blur();
				}
			});

			$.event('wheel', input_1, (event) => onStopPositionWheel()(focusedStop().id, focusedStop().position, event));
			$.delegated('input', input_2, (event) => onStopAlphaInput()(focusedStop().id, event.currentTarget.value));
			$.event('wheel', input_2, (event) => onStopAlphaWheel()(focusedStop().id, focusedStop().alpha, event));
			$.append($$anchor, div_7);
		};

		var alternate = ($$anchor) => {
			var div_11 = root_5();
			var text_9 = $.only_child(div_11, true);

			$.template_effect(() => $.set_text(text_9, noStopSelectedLabel()));
			$.append($$anchor, div_11);
		};

		$.if(node_4, ($$render) => {
			if (focusedStop()) $$render(consequent_3); else $$render(alternate, -1);
		});
	}

	$.reset(div);
	$.template_effect(() => $.set_text(text, stopEditorLabel()));
	$.append($$anchor, div);

	return $.pop($$exports);
}

$.delegate(['click', 'pointerdown', 'input', 'keydown']);

$.create_custom_element(
	Lut_editor_stop_section,
	{
		selectedRamp: {},
		focusedStop: {},
		stopPositionDraft: {},
		editingStopPositionId: {},
		stopEditorLabel: {},
		addStopLabel: {},
		removeStopLabel: {},
		duplicateStopLabel: {},
		invertStopLabel: {},
		stopMenuAriaLabel: {},
		stopColorLabel: {},
		stopPositionLabel: {},
		alphaLabel: {},
		noStopSelectedLabel: {},
		maxStopsReached: {},
		isStopBoundary: {},
		onAddStop: {},
		onRemoveStop: {},
		onDuplicateFocusedStop: {},
		onInvertFocusedStop: {},
		onSelectStop: {},
		onPreviewStopPointerDown: {},
		onStopColorInput: {},
		onBeginStopPositionEdit: {},
		onStopPositionInput: {},
		onCommitStopPosition: {},
		onCancelStopPositionEdit: {},
		onStopPositionWheel: {},
		onStopAlphaInput: {},
		onStopAlphaWheel: {}
	},
	[],
	[],
	{ mode: 'open' }
);